import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import s from './SellYourArtLink.scss';
// todo: merge with more specific (SEO-wise) url in da-url
var DEVIANTART_SELL_URL = 'https://www.deviantartsell.com';
export var EditButton = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(ActionBarItemWrapper, { className: className, popoverWrapperClassName: s['wrapper'] },
        React.createElement(ActionBarButton, { className: s['button'], href: DEVIANTART_SELL_URL, biData: BiData({
                evid: 353,
                deviationid: deviation === null || deviation === void 0 ? void 0 : deviation.deviationId,
            }) }, t('actionbar.sellYourArt'))));
};
EditButton.displayName = 'EditButton';
export default EditButton;
//# sourceMappingURL=SellYourArtLink.js.map